import { ExclamationMarkCircleFilled } from "components/icons/generated";
import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import Typography from "ds/components/Typography";
import { getNowTimeMs, unixTimestampToMs } from "utils/time";

import { PersonalApiKey } from "../../gql";

const PersonalApiKeysTableExpiresAtCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<PersonalApiKey>) => {
  const expiresAt = apiKey.expiresAt;

  if (!expiresAt) {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellText>Never expires</TableCellText>
      </TableSimpleCell>
    );
  }

  const isExpired = unixTimestampToMs(expiresAt) <= getNowTimeMs();

  if (isExpired) {
    return (
      <TableSimpleCell {...cellProps}>
        <Box direction="row" align="center" gap="small">
          <Icon src={ExclamationMarkCircleFilled} color="danger" noShrink />
          <Typography tag="span" variant="p-body3" color="danger">
            Expired
          </Typography>
        </Box>
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp variant="p-body3" timestamp={expiresAt} />
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableExpiresAtCell;
